<template>
  <SnippetList />
</template>
<script>
// @ is an alias to /src
import SnippetList from "@/components/SnippetList.vue";

export default {
  name: "Snippets",
  components: {
    SnippetList,
  },
};
</script>
